module.exports = __webpack_public_path__ + "resources/img/solution_game_m.fa638b6176af46701b0b94ad22f40a7b.png";